<template>
  <CustomModal :visible="$store.state.confirmationOverlay.visible"
               :heading="$store.state.confirmationOverlay.heading?
               $store.state.confirmationOverlay.heading:'Aktion bestätigen'"
               @close="$store.state.confirmationOverlay.visible=false"
  >
    <div style="margin-bottom: 20px;">{{ $store.state.confirmationOverlay.text }}</div>
    <SecondaryButton style="margin-right: 10px;" text="Abbrechen" @click="_cancel" />
    <PrimaryButton text="Bestätigen" @click="_confirm" />
  </CustomModal>
</template>

<script>
import PrimaryButton from "@/components/elements/PrimaryButton";
import SecondaryButton from "@/components/elements/SecondaryButton.vue";
import CustomModal from "@/components/elements/CustomModal";

export default {
  components: {
    SecondaryButton,
    PrimaryButton,
    CustomModal,
  },
  props: [
    "model",
  ],
  methods: {
    _confirm() {
      this.$store.state.confirmationOverlay.resolve(true);
      this.$store.state.confirmationOverlay.visible = false;
    },
    _cancel() {
      this.$store.state.confirmationOverlay.resolve(false);
      this.$store.state.confirmationOverlay.visible = false;
    },
  },
}
</script>